import moment from "moment";
import React, { Component } from "react";
import BatchJobExtractionServices from "../../services/axiosServices/apiServices/BatchJobExtractionServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { saveAs } from "file-saver";
import PageLoader from "../../components/common/pageLoader/PageLoader";

export default class GSTReport extends Component {
    constructor(props) {
        super(props);
        this.batchJobExtractionServices = new BatchJobExtractionServices();
        this.swalServices = new SwalServices();
        this.state = {
            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "CreatedAt",
                orderFlag: 0,
                searchText: "",
                searchSpecificDate: "",
            },
            isLoading: false,
            GSTReportList: [],
            totalCount: 0,

            generateGSTReportdetails: {
                currentDate: new Date(),
                startDate: "",
                endDate: "",
            }

        };
    }

    componentDidMount = () => {
        this.getAllGSTReportList();

    }

    getAllGSTReportList = () => {
        this.setState({ isLoading: true });
        let pagination = { ...this.state.pagination };
        this.batchJobExtractionServices.getAllGSTReportList(pagination).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                let details = response.responseItem.responseContent.itemList;
                this.setState({
                    GSTReportList: details,
                    totalCount: response.responseItem.responseContent.totalCount,
                })
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        });
    }


    generateGSTReport = () => {
        if (this.state.generateGSTReportdetails.startDate && this.state.generateGSTReportdetails.endDate) {
            if (this.state.generateGSTReportdetails.startDate < this.state.generateGSTReportdetails.endDate) {
                this.setState({ isLoading: true });
                let request = {
                    currentDate: this.state.generateGSTReportdetails.currentDate,
                    startDate: this.state.generateGSTReportdetails.startDate,
                    endDate: this.state.generateGSTReportdetails.endDate,
                };
                this.batchJobExtractionServices.generateGSTReport(request).then((response) => {
                    if (response.statusCode === 200 && response.responseItem != null) {
                        this.swalServices.Success("GST report generated successfully");
                        this.getAllGSTReportList();
                    }
                    else if (response.statusCode === 409) {
                        this.swalServices.Error(response.message);
                    }
                    else {
                        this.swalServices.Error(response.message);
                    }
                    this.setState({ isLoading: false });
                });
            }
            else {
                this.swalServices.Alert('End date should not be grater than start date');
            }
        }
        else {
            this.swalServices.Alert('Please select date');
        }
    }



    downloadGSTSheetByGSTReportId = (gstReportId) => {
        this.setState({ isLoading: true });
        let request = [];
        request.push(gstReportId);
        this.batchJobExtractionServices.downloadGSTSheetByGSTReportId(request)
        .then((response) => { 
            if (response.status === 200 && response.data != null) {
                // var filename = `${detail}${formattedDate}`;
                let blob = new Blob([response.data])
                // saveAs(blob, `GSTReport` + ".xlsx");
                saveAs(blob, `GSTReport.xlsx`);
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        })
        .catch((error)=>{ 
                this.swalServices.Error("No records found.");
                this.setState({ isLoading: false });
        })
    }

    handleChange = (e, type) => {
        let name = e.target.name;
        let value = e.target.value;
        if (type === "Pagination") {
            let data = { ...this.state.pagination }
            data[name] = value;
            this.setState({ pagination: data }, () => {
                this.getAllGSTReportList();
            });
        }
        if (type === "GenerateReport") {
            let data = { ...this.state.generateGSTReportdetails }
            data[name] = value;
            this.setState({ generateGSTReportdetails: data });
        }
    }

    render() {
        return (
            <div className="main-body-section finance-body-sec">
                {/* Business Transaction Batch Job Start */}

                <div className="bg-white">
                    {/* <div className="heading-part pl-7 py-4 border-b">
                        <div className="flex items-center justify-between">
                            <h4 className="small-title font-bold theme-color">
                                Business Transaction Batch Job
                            </h4>
                        </div>
                    </div> */}

                    <div className="grid grid-cols-12 gap-6 w-full items-center px-8 py-10">
                        <div className=" 2xl:col-span-3 lg:col-span-3 col-span-12 w-full hidden">
                            <h2 className="text-xl theme-color mb-1">
                                Invoice Number
                                <span className="text-[#C00000]">*</span>
                            </h2>
                            <input
                                id="default"
                                name="filterbyInvoiceNumber"
                                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                                type="text"
                            // onChange={(event) => this.handleChange(event)}
                            // value={this.state.pagination.filterbyInvoiceNumber}
                            />
                        </div>
                        <div className="col-span-3">
                            <label
                                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                                htmlFor="default"
                            >
                                Start Date <span className="text-[#C00000]">*</span>
                            </label>
                            <div className="">
                                <input
                                    id="startDate"
                                    name="startDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={moment(this.state.generateGSTReportdetails.startDate).format("yyyy-MM-DD")}
                                    onChange={(event) => this.handleChange(event,"GenerateReport")}
                                //disabled
                                />
                            </div>
                        </div>
                        <div className="col-span-3">
                            <label
                                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                                htmlFor="default"
                            >
                                End Date <span className="text-[#C00000]">*</span>
                            </label>
                            <div className="">
                                <input
                                    id="endDate"
                                    name="endDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={moment(this.state.generateGSTReportdetails.endDate).format("yyyy-MM-DD")}
                                    onChange={(event) => this.handleChange(event,"GenerateReport")}
                                //disabled
                                />
                            </div>
                        </div>
                        <div className="col-span-4">
                            <button className="btn btn-red text-xl border text-white mt-8" onClick={() => this.generateGSTReport()}>
                                Generate GST Report
                            </button>
                        </div>
                        <div className="col-span-3">
                            <label
                                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                                htmlFor="default"
                            >
                                Search
                            </label>
                            <div className="">
                                <input
                                    id="searchSpecificDate"
                                    name="searchSpecificDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={moment(this.state.pagination.searchSpecificDate).format("yyyy-MM-DD")}
                                    onChange={(event) => this.handleChange(event, "Pagination")}
                                //disabled
                                />
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-6 w-full items-center justify-center px-8 py-10">
                        <div className="2xl:col-span-12 lg:col-span-12 col-span-12 w-full">
                            {this.state.isLoading ? <PageLoader /> :
                                <table className="w-full mx-auto my-5 fixed_header batch-job-extraction-table border">
                                    <thead>
                                        <tr className="text-base font-bold flex">
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[20%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                    Start Date
                                                </div>
                                            </th>
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[20%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                    End Date
                                                </div>
                                            </th>
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[20%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                    Generated Date
                                                </div>
                                            </th>
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[20%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                    Number of Records
                                                </div>
                                            </th>
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[20%]">
                                                <div className="font-bold tble-th-txt text-center">Action</div>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody className="scrollit text-sm custom-tbody">
                                        {this.state.GSTReportList.map((e, key) => {
                                            return (
                                                <tr className="custom-tbl-td flex items-center" key={key}>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%] ">
                                                        {moment(e.startDate).format("DD MMM YYYY")}
                                                    </td>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%] ">
                                                        {moment(e.endDate).format("DD MMM YYYY")}
                                                    </td>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%] ">
                                                        {moment(e.generationDate).format("DD MMM YYYY")}
                                                    </td>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                                        {e.numberOfRecords}
                                                    </td>

                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                                        <button
                                                            className="action-btn mx-auto flex items-center"
                                                            aria-controls="add-edit-modal"
                                                            onClick={() => {
                                                                this.downloadGSTSheetByGSTReportId(e.gstReportId);
                                                            }}
                                                        >
                                                            <p className="ml-2 tool-tip-txt underline text-[#81a3b8]">
                                                                Download
                                                            </p>
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}

                                    </tbody>
                                </table>
                            }
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
